import { matchesString } from './utils/filter-options';
function getMatchingFilteringTags(filteringTags, highlightText) {
    if (!highlightText || !filteringTags) {
        return [];
    }
    return filteringTags.filter(filteringTag => matchesString(filteringTag, highlightText, false));
}
function defaultOptionDescription({ option, parentGroup, highlightText }) {
    return [
        parentGroup && parentGroup.label,
        option.__labelPrefix,
        option.label || option.value,
        option.description,
        option.labelTag,
    ]
        .concat(option.tags)
        .concat(getMatchingFilteringTags(option.filteringTags, highlightText))
        .filter(el => !!el)
        .join(' ');
}
export default defaultOptionDescription;
//# sourceMappingURL=option-announcer.js.map